<template>
    <search-group title="抄表查询" @search="find" @clear="clearValue" :span="10">
        <Row>
            <Col span="3" class="zr-label">项目名称</Col>
            <Col span="9">
                 <Select v-model="searchParams.projectFid">
                    <Option value="100" v-for="item in list.projectList" :value="item.value" :key="item.value">{{item.text}}</Option>
                </Select>
            </Col>
            <Col span="3" class="zr-label">状态</Col>
            <Col span="9">
                 <Select v-model="searchParams.readStatus">
                    <Option value="100" v-for="item in list.readStatusList" :value="item.value" :key="item.value">{{item.text}}</Option>
                </Select>
            </Col>
        </Row>
    </search-group>
</template>

<script type="text/ecmascript-6">
// import SearchGroup from 'components/SearchGroup/index';
import { getReadStatus } from "api/meterReading";
import { getProjects } from "api/common";
export default {
    components: {
        // SearchGroup
    },
    data () {
        return {
            list:{
                projectList:[],
                readStatusList:[]
            },
            searchParams:{
                projectFid:'',
                readStatus:null,
                page:1,
                limit:10,
            }
        }
    },
    created () {
        this.initList();
    },
    methods: {
        find() {
            this.$emit('search-data',this.searchParams)
        },
        clearValue() {
            this.searchParams.projectFid = '';
            this.searchParams.readStatus = null;
        },
        initList() {
            getProjects().then(res => {
                this.list.projectList = res.data
            })
            getReadStatus().then(res => {
                this.list.readStatusList = res.data
            })
        }
    }
}
</script>
